export default __webpack_public_path__ + "static/media/intro_img.289a7879.png";